import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

/* Login page → Forgot password? (POST /auth/forgot-password). An ERP e-mail
   login gets a reset link by e-mail; an employee-code login (HR password)
   sends a request to the admins, who give a new temporary password. The
   answer never says whether the account exists. */
export default function ForgotPassword({ open, onOpenChange, initial = "" }) {
  const [ident, setIdent] = useState("");
  const [done, setDone] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setIdent(initial && initial !== "admin@alupipe.com" ? initial : ""); setDone(""); setError(""); } }, [open, initial]);

  const send = async (e) => {
    e.preventDefault();
    if (!ident.trim()) return;
    setBusy(true); setError("");
    try { const { data } = await api.post("/auth/forgot-password", { ident: ident.trim() }); setDone(data.message); }
    catch (err) { setError(formatApiError(err?.response?.data?.detail) || err.message); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="forgot-password">
        <form onSubmit={send}>
          <DialogHeader>
            <DialogTitle>Forgot your password?</DialogTitle>
            <DialogDescription>
              Enter your e-mail or employee code. With an e-mail login you get a link to choose a new password. With an
              employee code, your admin is asked to give you a new password.
            </DialogDescription>
          </DialogHeader>
          {done ? (
            <div className="my-4 rounded-md border border-green-200 bg-green-50 text-green-800 text-sm px-3 py-2" data-testid="forgot-password-done">{done}</div>
          ) : (
            <div className="my-4 space-y-1.5">
              <Label htmlFor="fp-ident">Email or employee code</Label>
              <Input id="fp-ident" value={ident} onChange={(e) => setIdent(e.target.value)} autoCapitalize="off" spellCheck={false} required data-testid="forgot-password-ident" />
              {error && <div className="text-sm text-red-600">{error}</div>}
            </div>
          )}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>{done ? "Close" : "Cancel"}</Button>
            {!done && <Button type="submit" disabled={busy} className="bg-blue-600 hover:bg-blue-700" data-testid="forgot-password-send">Send</Button>}
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
